import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// material-ui
import { ButtonBase, SxProps, Theme } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

// project import
import Logo from './Logo';
import config from 'config';
import { activeItem } from 'store/reducers/menu';
import { MenuState, Store } from 'store/types';
import { PropsWithoutRef } from 'react';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = (
    props: PropsWithoutRef<{ sx?: SxProps<Theme>; to?: string | null; open?: boolean; }>,
) => {
    const { sx, to, open } = props;
    const { defaultId } = useSelector<Store, MenuState>(state => state.menu);
    const dispatch = useDispatch();
    return (
        <ButtonBase
            disableRipple
            component={Link}
            onClick={() => dispatch(activeItem({ openItem: [defaultId] }))}
            to={!to ? config.defaultPath : to}
            sx={{ ...sx, width: '100%' }}>
            <Logo open={open} height={35} />
        </ButtonBase>
    );
};

LogoSection.propTypes = {
    sx: PropTypes.object,
    to: PropTypes.string,
};

export default LogoSection;
